import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jquqgry9jx: FaireBrandEntity = {
  token: "b_jquqgry9jx",
  type: "brand",
  name: "39F Inc.",
  avatarUrl:
    "https://cdn.faire.com/fastly/9a89ea7c7439d92ac83c05fd671a3f98f2211aade7ffb70316f58ff88d61f3e3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/590cae60e8dbbd7cb2c536ab0e5969f9b191c9fe0345f8526d52c26c30124c45.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9a89ea7c7439d92ac83c05fd671a3f98f2211aade7ffb70316f58ff88d61f3e3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/590cae60e8dbbd7cb2c536ab0e5969f9b191c9fe0345f8526d52c26c30124c45.png",
  location: "Jonesboro, GA, USA",
  minimumOrderDollars: 99,
  rating: 4.8,
  reviewCount: 261,
  isTopShop: true,
  isInsider: false,
  description:
    "39F INC is a modern furniture supplier specializing in stylish, versatile pieces designed to elevate furniture stores, boutiques, gift shops, home décor stores, and apparel shops alike. Our collections blend contemporary design with practical function, helping independent retailers create unique spaces that inspire their customers. We believe great furniture isn’t just for homes — it brings stories, comfort, and visual identity to any retail environment.\n\nFounded with a passion for thoughtful design and quality craftsmanship, 39F INC began by working closely with local artisans and design studios to craft furniture that balances modern style and everyday usability. From display tables and seating to versatile storage solutions, each piece is carefully curated to help furniture stores and other retailers express their brand’s personality and delight their customers. We’re proud to support small businesses with flexible minimums, customizable options, and reliable service that grows with your store.\n\nFor more information, please message us on Faire or email us by [redacted-email] or Call[redacted-phone]. We'll be happy to be of service.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:06.388Z",
    importedBy: "entity-db-cli",
  },
};
